import { observer } from "mobx-react";
import React from "react";

import { SuggestedListEvent } from "@components/header/desktop/components/search/SuggestedListEvent";
import { SuggestedListTournament } from "@components/header/desktop/components/search/SuggestedListTournamentItem";
import { SuggestedSearchListItemType } from "@data-types/suggested-search/SuggestedSearchListItemType";
import { useRootAppStore } from "@hooks";
import { ErrorMessage } from "@components/inputs/shared";
import { HeaderFreeSearchListItem } from "./HeaderFreeSearchListItem";

export const HeaderSuggestedSearchList = observer(
	function HeaderSuggestedSearchList() {
		const store = useRootAppStore().searchStore;

		return (
			<ul className="popup--search__list">
				<ErrorMessage
					name={"search"}
					customErrorClassName={
						"popup--search__term popup--search__term--error message--validation field-validation-error"
					}
				/>

				<HeaderFreeSearchListItem />

				{store.filteredSearchList?.map((item) => {
					if (item.type == SuggestedSearchListItemType.Event) {
						return (
							<SuggestedListEvent item={item} key={item.key} />
						);
					}
					return (
						<SuggestedListTournament item={item} key={item.key} />
					);
				})}
			</ul>
		);
	}
);
